module.exports = __webpack_public_path__ + "img/lang.715ce37a.png";